import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: null,
};

const onBoardingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ONBOARDING_STEP_COMPLETE_START:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.ONBOARDING_STEP_COMPLETE_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.ONBOARDING_STEP_COMPLETE_FAIL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default onBoardingReducer;